import { dateRangeStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldDateRange";
import { css } from "styled-components";

Object.assign(dateRangeStyles, {
    datePickersWrapper: {
        css: css`
            justify-content: space-between;
            display: flex;
            & > div {
                flex-basis: 50%;
            }
        `,
    },
});
